import React, { useState, useCallback } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { useHistory } from 'react-router-dom';
import AuthenticationTransition from '../Common/AuthenticationTransition';
import './Login.css';
import whitelogo from 'Assets/white-logo.png';
import logo from 'Assets/logo.jpg';

/**
 * Login Component
 * Handles user authentication with Okta
 */
const Login = () => {
  const { oktaAuth, authState } = useOktaAuth();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [status, setStatus] = useState('');

  const handleRetry = useCallback(async () => {
    setError(null);
    setStatus('Retrying authentication...');
    await handleLogin();
  }, []);

  const handleLogin = async () => {
    try {
      setLoading(true);
      setError(null);

      // Redirect to Okta hosted login page
      await oktaAuth.signInWithRedirect({
        originalUri: window.location.origin,
      });
    } catch (err) {
      console.error('Login error:', err);
      setError('Failed to initiate login. Please try again.');
      setLoading(false);
    }
  };

  if (loading || error) {
    return (
      <AuthenticationTransition
        message={
          loading ? 'Redirecting to Okta login...' : 'Authentication Error'
        }
        status={status}
        error={error}
        onRetry={error ? handleRetry : undefined}
        isLoading={loading}
      />
    );
  }

  return (
    <div className="login-page">
      <div className="login-header">
        <img src={whitelogo} className="whitelogo" />
        <a
          href="https://smithfieldfoods.service-now.com/"
          className="tech-support"
        >
          Technology Support
        </a>
      </div>
      <div className="login-container" id="login-container">
        <div className="form-container">
          <form className="login-form" action="#">
            <img className="login-logo" src={logo} />

            <p style={{ color: 'red' }}>
              {error && (
                <div className="error-message" role="alert">
                  {error}
                </div>
              )}
            </p>
            <button
              className="login-button"
              onClick={handleLogin}
              disabled={loading}
              aria-label="Sign in with Okta"
            >
              {loading ? (
                <>
                  <span className="loading-spinner"></span>
                  Signing in...
                </>
              ) : (
                'Sign In'
              )}
            </button>
            <div className="login-footer">
              <p>Secured by Okta</p>
            </div>
          </form>
        </div>
      </div>
    </div>
    /*
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h2>Welcome to Grain Hedging</h2>
          <p>Please sign in to access your account</p>
        </div>

        <div className="login-content">
          {error && (
            <div className="error-message" role="alert">
              {error}
            </div>
          )}

          <button
            className="login-button"
            onClick={handleLogin}
            disabled={loading}
            aria-label="Sign in with Okta"
          >
            {loading ? (
              <>
                <span className="loading-spinner"></span>
                Signing in...
              </>
            ) : (
              'Sign In'
            )}
          </button>

          <div className="login-footer">
            <p>Secured by Okta</p>
          </div>
        </div>
      </div>
    </div>
    */
  );
};

export default Login;
